import { createFileRoute } from "@tanstack/react-router";
import { CyclePage } from "@/features/cycles/CyclePage";

export const Route = createFileRoute("/_app/cycles/$cycle")({ component: Page });

function Page() {
  const { cycle } = Route.useParams();
  return <CyclePage id={cycle} />;
}
